var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDark = function SvgDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M10 1.667c.687 0 1.354.085 1.992.241a.835.835 0 0 1 .298 1.48A6.66 6.66 0 0 0 9.583 8.75c0 3.13 2.16 5.756 5.071 6.472a.834.834 0 0 1 .297 1.48A8.333 8.333 0 0 1 1.667 10 8.333 8.333 0 0 1 10 1.666m-.083 1.668a6.666 6.666 0 1 0 2.572 12.849A8.33 8.33 0 0 1 7.917 8.75a8.3 8.3 0 0 1 2-5.415"
  })));
};
export default SvgDark;